import styled from 'styled-components'

interface StyleProps {
  fontSize?: string
}
interface TextLabelStyles {
  style: StyleProps
  normal?: boolean
  maxWidth?: string
  withoutMargin?: boolean
  uppercase?: boolean
  fontWeight?: string
  whiteSpace?: string
}

export const TextLabel = styled.p<TextLabelStyles>`
  font-size: ${props => (!props.style.fontSize ? '13px' : props.style.fontSize)};
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'none')};
  color: ${({ color, theme }) => color ?? theme.colors.color2d3139};
  margin-bottom: ${({ withoutMargin, theme }) => !withoutMargin && theme.zds.spacing.stack300};
  font-weight: ${props => props.fontWeight ?? (!props.normal ? 'bold' : 'normal')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  white-space: ${({ whiteSpace }) => whiteSpace ?? 'normal'};
  strong {
    font-weight: 500;
    text-transform: none;
    font-size: ${props => (!props.style.fontSize ? '13px' : props.style.fontSize)};
  }
`
